import React from 'react';
import { MapPin, TrendingDown, Users } from 'lucide-react';
export function Diagnosis() {
  const problems = [{
    icon: <MapPin className="w-8 h-8 text-emerald" data-id="element-8" />,
    title: 'Problema 1: Invisibilidad Digital',
    description: 'Un restaurante sin sistema digital depende del tráfico peatonal. Y el tráfico peatonal está muriendo. La gente decide dónde comer en su teléfono, no caminando por la calle. Si no apareces en Google Maps, Yelp y redes sociales con una presencia de autoridad, eres invisible para el 80% de tus clientes potenciales.'
  }, {
    icon: <TrendingDown className="w-8 h-8 text-emerald" data-id="element-9" />,
    title: 'Problema 2: El Costo de las Mesas Vacías',
    description: 'Las mesas vacías entre semana cuestan lo mismo que las llenas. Renta, staff, ingredientes. Todo tiene el mismo costo independientemente de si tienes 5 o 50 comensales. Un sistema de marketing activo que llene específicamente los días de semana puede duplicar tu facturación sin agregar un solo comensal el fin de semana.'
  }, {
    icon: <Users className="w-8 h-8 text-emerald" data-id="element-10" />,
    title: 'Problema 3: Fuga de Clientes',
    description: 'Los clientes que no regresan son el mayor costo oculto. Conseguir un cliente nuevo cuesta 5 veces más que retener uno que ya te conoce. Sin un sistema de fidelización automatizado, estás tirando dinero en publicidad para atraer personas que solo vienen una vez.'
  }];
  return <section className="py-16 md:py-24 px-4 border-b border-gray-900 bg-[#0a0a0a]" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-4" data-id="element-14">
            El Diagnóstico
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-15">
            Entender por qué estás perdiendo dinero es el primer paso para
            solucionarlo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-16">
          {problems.map((problem, index) => <div key={index} className="bg-carbon border border-gray-800 p-8 rounded-sm hover:border-gray-700 transition-colors" data-id="element-17">
              <div className="bg-gray-900/50 w-16 h-16 rounded-sm flex items-center justify-center mb-6" data-id="element-18">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-19">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-20">
                {problem.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}